import { IPTableColumnInfo, ITitle, TitleTypes } from '@libs/common-components';
import { TaxonomyDimension } from '../../models/ICampaignFilterContext';

export class AiCampaignsViewConstants {
  public static readonly aiRecommendationsTitleConfigs: ITitle[] = [
    {
      title: `AI Recommendations <img
        src="assets/images/sparkles.svg"
        alt="AI sparkles icon" />`,
      type: TitleTypes.h4,
      subTitle: null,
      styleClass: 'h5 text-gray-1000'
    },
    {
      title:
        'Review and approve the mappings for these campaigns. <span class="text-blue-600 b2 cursor-pointer ai-learn-more-link" data-action="learn-more">Learn more</span>',
      type: TitleTypes.info,
      subTitle: null,
      styleClass: 'text-gray-800 b1'
    }
  ];

  public static readonly unmappedTitleConfigs: ITitle[] = [
    {
      title: 'Other Unmapped Campaigns',
      type: TitleTypes.h4,
      subTitle: null,
      styleClass: 'h5 text-gray-1000'
    },
    {
      title:
        'Map these campaigns to their appropriate channels, tactics, and segments.',
      type: TitleTypes.info,
      subTitle: null,
      styleClass: 'text-gray-800 b1'
    }
  ];

  public static readonly mappedTitleConfigs: ITitle[] = [
    {
      title: 'Mapped Campaigns',
      type: TitleTypes.h4,
      subTitle: null,
      styleClass: 'h5 text-gray-1000'
    },
    {
      title:
        'These campaigns have been mapped, but you can edit their mappings if necessary.',
      type: TitleTypes.info,
      subTitle: null,
      styleClass: 'text-gray-800 b1'
    }
  ];

  public static readonly underProcessingTitleConfigs: ITitle[] = [
    {
      title: 'Mapping In Progress',
      type: TitleTypes.h4,
      subTitle: null,
      styleClass: 'h5 text-gray-1000'
    },
    {
      title:
        'These campaigns are currently being mapped, but you can still edit their mappings if necessary.',
      type: TitleTypes.info,
      subTitle: null,
      styleClass: 'text-gray-800 b1'
    }
  ];

  public static readonly aiRecommended = 'aiRecommended';

  public static readonly aiCampaignViewHeaders: Record<
    TaxonomyDimension,
    IPTableColumnInfo[]
  > = {
    [TaxonomyDimension.compositeDataSourceName]: [
      {
        field: 'recommendedChannel',
        header: 'Channel',
        width: '15rem !important',
        isFilterEnabled: true
      },
      {
        field: 'recommendedTactic',
        header: 'Tactic',
        width: '18rem !important',
        isFilterEnabled: true
      },
      {
        field: 'recommendedSegment',
        header: 'Segment',
        width: '15rem !important',
        isFilterEnabled: true
      },
      {
        field: 'spend',
        header: 'Spend',
        width: '7rem !important'
      }
    ],
    [TaxonomyDimension.tactic]: [
      {
        field: 'compositeDataSourceName',
        header: 'Data Source',
        width: '18rem !important',
        isFilterEnabled: true
      },
      {
        field: 'recommendedChannel',
        header: 'Channel',
        width: '15rem !important',
        isFilterEnabled: true
      },
      {
        field: 'recommendedSegment',
        header: 'Segment',
        width: '15rem !important',
        isFilterEnabled: true
      },
      {
        field: 'spend',
        header: 'Spend',
        width: '7rem !important'
      }
    ],
    [TaxonomyDimension.channel]: [
      {
        field: 'compositeDataSourceName',
        header: 'Data Source',
        width: '18rem !important',
        isFilterEnabled: true
      },
      {
        field: 'recommendedTactic',
        header: 'Tactic',
        width: '15rem !important',
        isFilterEnabled: true
      },
      {
        field: 'recommendedSegment',
        header: 'Segment',
        width: '15rem !important',
        isFilterEnabled: true
      },
      {
        field: 'spend',
        header: 'Spend',
        width: '7rem !important'
      }
    ],
    [TaxonomyDimension.segment]: [
      {
        field: 'compositeDataSourceName',
        header: 'Data Source',
        width: '18rem !important',
        isFilterEnabled: true
      },
      {
        field: 'recommendedChannel',
        header: 'Channel',
        width: '15rem !important',
        isFilterEnabled: true
      },
      {
        field: 'recommendedTactic',
        header: 'Tactic',
        width: '15rem !important',
        isFilterEnabled: true
      },
      {
        field: 'spend',
        header: 'Spend',
        width: '7rem !important'
      }
    ]
  };
}
